import { render, staticRenderFns } from "./TabOrderList.vue?vue&type=template&id=2d689fc8&scoped=true"
import script from "./TabOrderList.vue?vue&type=script&lang=js"
export * from "./TabOrderList.vue?vue&type=script&lang=js"
import style0 from "./TabOrderList.vue?vue&type=style&index=0&id=2d689fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d689fc8",
  null
  
)

export default component.exports